import axios from 'axios';
import { Loading } from 'tspuser-toc-vue-modules';

class WxPackage {
  constructor() {
    /**
     * status
     * 0 未就绪
     * 1 已成功
     * 2 已失败
     */
    this.status = 0;
    // 等待执行的方法队列
    this.operationQueue = [];
    if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
      document.addEventListener('WeixinJSBridgeReady', this.ready.bind(this), false);
    } else {
      this.ready();
    }
  }

  // web-view下的页面内
  ready() {
    // eslint-disable-next-line
    if (window.navigator.userAgent.indexOf('MicroMessenger') <= 0 && (window.__wxjs_environment !== 'miniprogram' || this.status !== 0)) {
      return this;
    }
    const setWxJsSDKConfig = () => {
      const params = {
        url: window.location.href.split('#')[0],
        brandCode: 2,
      };
      let apiurl; let
        appId;
      if (process.env.VUE_APP_ENV === 'prod') {
        apiurl = '/app-mp/saicmp/1.0/createJsapiSignature';
        appId = 'wx29c2d3cd56313d97';
      } else {
        apiurl = '/app-mp/saicmp/1.0/createJsapiSignatureForQa';
        appId = 'wx52c30ab1b6918d87';
      }
      // 错误处理
      function handleError() {
        Loading.close();
        console.error('微信授权失败,请点击重试！');
        // Alert({
        //   content: '微信授权失败,请点击重试！',
        //   confirm: '确定',
        // }).then(() => {
        //   setWxJsSDKConfig();
        // });
      }
      axios({
        url: `${process.env.VUE_APP_BASE_URL}${apiurl}`,
        params,
      }).then((res) => {
        if (res.data.err_resp) {
          handleError();
        } else {
          const config = res.data.data;
          console.log('wxconfig:>>>');
          console.log(config);
          wx.config({
            debug: false,
            appId, // 必填，公众号的唯一标识
            timestamp: config.timestamp, // 必填，生成签名的时间戳
            nonceStr: config.nonceStr, // 必填，生成签名的随机串
            signature: config.signature, // 必填，签名
            jsApiList: ['getLocation', 'openLocation', 'chooseImage', 'getLocalImgData'], // 必填，需要使用的JS接口列表
          });
          wx.error((res1) => {
            this.status = 2;
            console.log(res1);
            this.runOperationQueue();
            throw new TypeError('wx signature error');
          });
          wx.ready(() => {
            console.log('----------------wx.ready');
            this.status = 1;
            this.runOperationQueue();
          });
        }
      }).catch(() => handleError());
    };
    setWxJsSDKConfig();
    return this;
  }

  /**
   * 等待wxjssdk ready后执行方法
   * @param {Function} func
   */
  execute(key, func) {
    if (typeof key !== 'string' || typeof func !== 'function') {
      return this;
    }
    if (this.status === 1) {
      func();
    } else {
      this.operationQueue.push({
        key,
        func,
      });
    }
  }

  runOperationQueue() {
    // 执行方法
    const done = [];
    for (let i = 0; i < this.operationQueue.length; i += 1) {
      const obj = this.operationQueue[i];
      if (typeof obj.func === 'function' && done.includes(obj.key) === false) {
        done.push(obj.key);
        obj.func();
      }
    }
    this.operationQueue = [];
  }
}

const wxPackage = new WxPackage();

export default wxPackage;
